import {Customer} from './Customer';
import {Product} from './Product';
import {ContractItem} from './ContractItem';
import {ContractState} from './ContractState';
import {PaymentType} from './PaymentType';
import {CustomerContactPerson} from './CustomerContactPerson';
import {ContractItemType} from './ContractItemType';
import {VatRateService} from '../../services/vat-rate.service';
import {ContractEvent} from './ContractEvent';
import {BaseObject} from './BaseObject';

export class Contract extends BaseObject {
    id: number;
    number = '';

    customer: Customer = new Customer();
    customerId: number;
    contactId: number;
    event: ContractEvent = new ContractEvent();
    eventId: number;
    eshopId: number = null;

    fromStart: Date = new Date();
    fromEnd: Date = new Date();
    toStart: Date = new Date();
    toEnd: Date = new Date();
    daysCount = 0;
    termDescription = '';
    eshopDescription = '';

    manual = false;
    manualApproved = null;

    sale = 0;

    state: string = ContractState.new;

    paymentType: PaymentType = PaymentType.cash;
    invoiceNumber = '';
    paymentDate = '';
    paymentNote = '';

    delivery = false;
    deliveryInternalNote: string;
    backDeliveryInternalNote: string;
    deliveryStreet: string;
    deliveryCity: string;
    deliveryZip: string;
    deliveryContactPerson: string;
    deliveryPhone: string;
    deliveryEmail: string;
    deliveryBuilding: string;

    deliveryAddress: string;
    deliveryAddressLat: number;
    deliveryAddressLon: number;

    backDeliveryAddress: any;
    backDeliveryAddressLat: any;
    backDeliveryAddressLon: any;

    backDelivery = false;
    backDeliveryStreet: string;
    backDeliveryCity: string;
    backDeliveryZip: string;
    backDeliveryContactPerson: string;
    backDeliveryPhone: string;
    backDeliveryEmail: string;
    backDeliveryBuilding: string;

    hide: boolean = false;

    deployment = false;

    deploymentDescription: string;

    refundableDeposit = 0;
    lossSale = true;

    /**
     * Count of lost items
     * @type {number}
     */
    lost = 0;

    lostItems: ContractItem[] = [];

    items: ContractItem[] = [];

    isLoss = (): boolean => {
        if (this.state !== ContractState.returned) {
            return false;
        }

        return this.lost > 0;
    };

    totalPrices = (): any => {

        const prices = {
            totalPrice: 0,
            totalSalePrice: 0,
            totalDayPrice: 0,
            totalVatPrice: 0,
            totalVat: 0,
            totalDeliveryPrice: 0,
            totalDeploymentPrice: 0
        };

        for (const item of this.items) {

            switch (item.type) {
                case ContractItemType.product:
                case ContractItemType.group:
                case ContractItemType.other:
                    if (!item.isSell) {
                        prices.totalDayPrice += item.getTotalPrice();
                        if (item.daysChanged) {
                            prices.totalVat += item.getVat() * item.days;
                            prices.totalPrice += item.getTotalPrice() * item.days;
                            prices.totalVatPrice += item.getTotalVatPrice() * item.days;
                        } else {
                            prices.totalVat += item.getVat() * this.daysCount;
                            prices.totalPrice += item.getTotalPrice() * this.daysCount;
                            prices.totalVatPrice += item.getTotalVatPrice() * this.daysCount;
                        }
                    } else {
                        prices.totalDayPrice += item.getTotalPrice();
                        prices.totalVat += item.getVat();
                        prices.totalPrice += item.getTotalPrice();
                        prices.totalVatPrice += item.getTotalVatPrice();
                    }
                    break;
                case ContractItemType.delivery:
                    prices.totalDeliveryPrice += item.getTotalPrice();
                    prices.totalPrice += item.getTotalPrice();
                    prices.totalVat += item.getVat();
                    prices.totalVatPrice += item.getTotalVatPrice();
                    break;
                case ContractItemType.deployment:
                    prices.totalDeploymentPrice += item.getTotalPrice();
                    prices.totalPrice += item.getTotalPrice();
                    prices.totalVat += item.getVat();
                    prices.totalVatPrice += item.getTotalVatPrice();
                    break;
            }
        }

        prices.totalSalePrice = prices.totalPrice - (this.sale * (1 - VatRateService.getDefaultVatRate() / 100));
        prices.totalVatPrice -= this.sale;
        prices.totalVat -= (this.sale * (VatRateService.getDefaultVatRate() / 100));

        return prices;
    };

    hasNonDispatchedItems = (): boolean => {
        for (const i of this.items) {
            if (i.isText() || i.isDeployment() || i.isDelivery()) {
                continue;
            }

            if (i.lentCount > i.dispatched) {
                return true;
            }
        }

        return false;
    };

    hasNonReturnedItems = (): boolean => {
        for (const i of this.items) {
            if (i.isText() || i.isDeployment() || i.isDelivery()) {
                continue;
            }

            if (i.dispatched > i.returned) {
                return true;
            }
        }

        return false;
    };
}



// WEBPACK FOOTER //
// /app/src/model/Entities/Contract.ts